import DocumentEditor from './components/ArticlesEditor';
import DocumentPreview from './components/ArticlesPreview';
import getClipboardItem from './Articles.getContent';
import Icon from './Articles.icon';
import Page from './Articles.page';
import ArticlesLayout from './Articles.layout';

export default {
  DocumentEditor,
  DocumentPreview,
  getClipboardItem,
  Icon,
  CustomPage: Page,
  CustomLayout: ArticlesLayout,
};
